<template>

    <v-page-section>
        <template #title>Options</template>
        <template #body>
            <v-form-group label="Smart Sending" caption="Days to wait before messaging the same customer again if smart sending is enabled.">
                <v-input-group class="w-200" input-group-append="Days" :model="params.send_interval" @input="params.send_interval = $event" />
            </v-form-group>
            <v-form-group label="Session Timeout" caption="Minutes of inactivity required before another customer session is logged.">
                <v-input-group class="w-200" input-group-append="Minutes" :model="params.session_timeout" @input="params.session_timeout = $event" />
            </v-form-group>
            <v-form-group label="Currency" caption="Default currency formatting for customer traits and event properties.">
                <v-select class="w-400" :model="params.currency" @input="params.currency = $event">
                    <option v-for="c in currencies" :key="c.code" :value="c.code">{{ c.code }} - {{ c.currency }}</option>
                </v-select>
            </v-form-group>
            <v-form-group label="Footer Block" caption="Add a custom block to the bottom of all your emails. Useful for addresses, disclaimers, and review requests.">
                <v-select class="w-400" :model="params.footer_block_id || ''" @input="params.footer_block_id = $event">
                    <option value="">Select Block</option>
                    <option v-for="b in project.blocks" :key="b.id" :value="b.id">{{ b.name }}</option>
                </v-select>
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" :loading="loading" @click.native="updateOptions">Save</v-button>
        </template>
    </v-page-section>

</template>

<script>

import CurrencyCodes from 'currency-codes';
import ProjectApi from '@api/ProjectApi';

export default {

    data() {
        return {
            currencies: CurrencyCodes.data,
            loading: false,
            params: {},
        }
    },

    mounted() {
        this.params = {
            send_interval: this.project.send_interval,
            session_timeout: this.project.session_timeout,
            currency: this.project.currency,
            footer_block_id: this.project.footer_block_id,
        };
    },

    methods: {

        updateOptions() {
            this.loading = true;
            ProjectApi.updateOptions(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>